import {utilLanguage} from "../util/utilLanguage.js";
import {fhr, map, resultmap, spinner} from '../../library/@lfi/resultmaps/dist/js/resultmap.js';
import {config} from './ergebnisabfrage-karteconfig.js';

const main = {
  /**
   * Fetch the JSON-stat from the service.
   * @returns {Promise<JsonStat>}
   * @private
   */
  fetchJsonStat(prodNr, prodItNr) {
    const segments = '/' + prodNr + '/' + prodItNr;
    return fetch(config.service.data + segments + '/jsonstat?modified=1')
      .then(fhr.json)
  },

  /**
   * Fetch the result table from the service.
   * @returns {Promise<String>} html
   * @private
   */
  fetchTable(prodNr, prodItNr, lang) {
    const segments = '/' + prodNr + '/' + prodItNr,
      options = {
        headers: new Headers({
          'Accept-Language': lang
        })
      },
      resource = config.service.data + segments + '/html?modified=1'

    return fetch(resource, options)
      .then(fhr.text);
  }
};

window.addEventListener('DOMContentLoaded', async () => {
  spinner.init();
  spinner.show();

  const lang = utilLanguage.get();
  document.querySelector('html').lang = lang;

  if (resultmap.query.has('prodNr') && resultmap.query.has('prodItNr')) {
    const prodNr = parseInt(resultmap.query.get('prodNr'));
    const prodItNr = parseInt(resultmap.query.get('prodItNr'));
    const responses = await Promise.all([
      main.fetchJsonStat(prodNr, prodItNr),
      main.fetchTable(prodNr, prodItNr, lang)
    ])
    await resultmap.init(responses[0], responses[1]);
    map.copyright.addReference('#' + prodItNr);
  }

  spinner.hide();
});